import { useUIStore } from '../stores/uiStore';

export function LoadingSpinner() {
  const loading = useUIStore(state => state.loading);

  if (!loading.isLoading) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="text-center">
          {/* Enhanced spinner */}
          <div className="flex justify-center mb-4">
            <div className="relative">
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200"></div>
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent absolute top-0 left-0"></div>
            </div>
          </div>

          {/* Loading message */}
          <p className="text-gray-900 font-semibold text-lg mb-2">
            {loading.message || 'Loading...'}
          </p>

          {/* Additional context */}
          <p className="text-gray-600 text-sm mb-4">
            This may take a few moments
          </p>

          {/* Progress bar */}
          {loading.progress !== undefined && (
            <div className="mt-4">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${loading.progress}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-2">{Math.round(loading.progress)}%</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
